import React from "react";
import { Link } from "react-router-dom";
import CcgRoutePremiumPage from "../components/CcgRoutePremiumPage";
import PostcodeQuotenew from "./PostcodeQuotenew";
import "./CcgRoutePremium.css";

const cardGrid = (className, cards) => (
  <div className={className}>
    {cards.map((card) => (
      <article className={card.className || ""} key={card.title}>
        <h3>{card.title}</h3>
        {card.body ? <p>{card.body}</p> : null}
        {card.items ? <ul>{card.items.map((item) => <li key={item}>{item}</li>)}</ul> : null}
        {card.link ? <Link to={card.link.to} className={card.link.className || "route-link-inline"}>{card.link.label}</Link> : null}
        {card.links ? <div className="route-link-btn-row">{card.links.map((link) => <Link to={link.to} className={link.className || "route-link-btn"} key={link.to}>{link.label}</Link>)}</div> : null}
      </article>
    ))}
  </div>
);

const taplowTaxiRoute = {
  id: "taplow-taxi",
  path: "/taplow-taxi",
  liveStripVariant: "maidenhead",
  seo: {
    title: "Taplow Taxi - Fixed-Price Heathrow Transfers & Local Cabs | CheapCabGrab",
    description:
      "Book reliable Taplow taxis for Heathrow, Taplow station, Cliveden, Thames-side hotels and local SL6 journeys. Fixed fares, licensed drivers, MPV options and 24/7 support.",
    keywords:
      "Taplow taxi, Taplow to Heathrow taxi, Taplow station taxi, Cliveden taxi, airport taxi Taplow, Taplow airport transfer, CheapCabGrab",
    canonical: "https://www.cheapcabgrab.com/taplow-taxi",
    ogTitle: "Taplow Taxi - Heathrow Transfers, Station Pickups and Local Cabs",
    ogDescription:
      "Fixed-price Taplow taxis for Heathrow, Taplow station, Cliveden and nearby Thames-side hotels with licensed drivers and online booking.",
    serviceName: "CheapCabGrab - Taplow Taxi Service",
    areaServed: ["Taplow", "Taplow Station", "Cliveden", "Maidenhead Bridge", "Heathrow Airport"],
    offerCatalogName: "Taplow Taxi Routes",
    offerName: "Taplow fixed-price taxi service",
    offerDescription: "Fixed-price taxi transfers from Taplow to Heathrow, local stations, hotels and nearby SL6 areas.",
    reservationName: "Taxi booking in Taplow",
  },
  hero: {
    eyebrow: "Taplow taxi service",
    h1: "Taplow Taxi - Fixed-Price Heathrow & Local Transfers",
    subtitle: "Taplow station, Cliveden, Thames-side hotels and Heathrow airport transfers.",
    body:
      "Book Taplow taxis with fixed upfront fares, licensed drivers and secure online booking. Ideal for Heathrow transfers, station pickups, Cliveden visits and local SL6 journeys.",
  },
  quote: {
    label: "Get instant Taplow taxi quotes",
    note: "Free - Fast - No obligation",
    presetPickup: "Taplow, SL6",
    presetDropoff: "",
  },
  flags: [
    "Fixed fares agreed upfront - no meters",
    "Taplow station, Cliveden and Heathrow pickups",
    "Licensed drivers, luggage-ready vehicles",
    "Saloon, MPV, minibus and coach options",
  ],
  reviewPageKey: "/taplow-taxi",
  reviewAriaLabel: "Taplow taxi customer reviews",
  lhrStatusTitle: "Live Heathrow checks for Taplow airport taxis",
  floatingCta: "Book Taplow Taxi",
  mobileCta: "Book Taplow Taxi",
  supportNudge: "Need Taplow taxi help?",
  sections: [
    {
      id: "taplow-overview",
      title: "Taplow taxis at a glance",
      body: "Taplow sits between Maidenhead, Burnham and the Thames corridor, with airport transfers, station pickups and hotel journeys all needing clear fixed pricing.",
      render: () => cardGrid("route-overview-grid", [
        {
          title: "Popular pickups",
          items: [
            "Taplow station and local residential streets",
            "Cliveden and nearby Thames-side stays",
            "Maidenhead Bridge and riverside restaurants",
            "Dorney, Burnham and Maidenhead edge pickups",
          ],
        },
        {
          title: "Airport transfer use cases",
          items: [
            "Heathrow departures from Taplow homes",
            "Hotel guests with luggage",
            "Families needing MPVs or child seats",
            "Business and leisure transfers to Heathrow",
          ],
        },
        {
          title: "Useful linked routes",
          links: [
            { to: "/taplow-to-heathrow", label: "Taplow to Heathrow" },
            { to: "/maidenhead-taxi", label: "Maidenhead taxi", className: "route-link-btn route-link-btn-secondary" },
          ],
        },
      ]),
    },
    {
      id: "taplow-areas",
      title: "Taplow local pickup coverage",
      body: "Taplow content is kept separate because local travel often involves station, river, Cliveden and Maidenhead-edge pickup points.",
      render: () => cardGrid("route-areas-grid", [
        {
          title: "Taplow station and local homes",
          items: [
            "Station pickups for Elizabeth line and GWR passengers",
            "Homes around Taplow village and the A4 corridor",
            "Short transfers to Maidenhead, Burnham and Slough",
          ],
          link: { to: "/taplow-to-heathrow", label: "Book Taplow to Heathrow ->" },
        },
        {
          title: "Cliveden and Thames-side travel",
          items: [
            "Cliveden visitor and hotel transfers",
            "Riverside restaurants and event pickups",
            "Airport transfers after leisure stays or weddings",
          ],
          link: { to: "/heathrow-hotels", label: "Heathrow hotel guide ->" },
        },
      ]),
    },
    {
      id: "taplow-faq",
      title: "Taplow taxi - FAQs",
      body: "Common questions for Taplow local and airport taxi bookings.",
      render: () => (
        <div className="route-faq-grid">
          {[
            ["Can you collect from Taplow station?", "Yes. Taplow station is a regular pickup point for local journeys, Heathrow transfers and onward travel to hotels or nearby towns."],
            ["Do you cover Cliveden and Thames-side hotels?", "Yes. We can collect from Cliveden and nearby Thames-side locations for Heathrow, local dinners, events and onward journeys."],
            ["Is Taplow to Heathrow available 24/7?", "Yes. Pre-booked Taplow airport transfers are available for early flights, late arrivals and overnight travel."],
            ["Can I book an MPV from Taplow?", "Yes. MPVs and minibuses are available for extra luggage, family groups and hotel bookings."],
          ].map(([title, body]) => <article className="route-faq-card" key={title}><h3>{title}</h3><p>{body}</p></article>)}
        </div>
      ),
    },
  ],
};

const TaplowTaxi = () => (
  <CcgRoutePremiumPage route={taplowTaxiRoute} QuoteComponent={PostcodeQuotenew} />
);

export default TaplowTaxi;
